export const AssessmentStatusCodes = {
    Initiated: 1,
    InProgress: 2,
    Completed: 4,
    Abort: 8,
    Pause: 16,
    Approved: 32,
    Rejected: 64,
    SamSubmitted: 128
};

export const accountTypes = {
    None: 1,
    Assessor: 2,
    Admin: 4,
    GlobalServiceAccount: 8,
    LocalServiceAccount: 16,
    Sam: 32,
    Track: 64
};

export const accountNames = {
    sam: 'Sam'
};
export const controlTypes = {
    hcid: 10109,
    mcid: 10110
};

export const assessmentTypes = {
    AHC: 65536
};
